var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-layer-vector',{attrs:{"render-mode":"image","z-index":997}},[[_c('vl-source-vector',{attrs:{"features":_vm.features}}),_c('vl-style-box',[(_vm.icon.display)?[_c('vl-style-icon',{attrs:{"src":_vm.iconSrc,"scale":1}})]:[_c('vl-style-circle',{attrs:{"radius":6}},[_c('vl-style-fill',{attrs:{"color":"#76FF03"}})],1)]],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }